import { call, put, takeEvery } from "redux-saga/effects";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../CommonApi/axios";
import headers from "../../../CommonApi/headers";
import { QRCODE, setQRCodeList } from "../../actions";

function* callQRCodeList() { 
  try {
      const response = yield call(api.get, "/groupadmin/settings/qr_code"  ,{ headers });
      const  tableData = response?.data?.data;
      console.log("tableData" ,tableData);
      yield put(setQRCodeList(tableData?.length > 0 ? tableData : []));
    } catch (error) {
      if (error.response) {
        yield put({ type: QRCODE.CLEAR_QRCODE_LIST });
      }
    }
}


export function* watchQRCodeList() {
  yield takeEvery(QRCODE.GET_QRCODE_LIST, callQRCodeList);
}

